import { render, staticRenderFns } from "./InitialForm_48.vue?vue&type=template&id=183c7ae7&scoped=true"
import script from "./InitialForm_48.ts?vue&type=script&lang=ts&external"
export * from "./InitialForm_48.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183c7ae7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('183c7ae7')) {
      api.createRecord('183c7ae7', component.options)
    } else {
      api.reload('183c7ae7', component.options)
    }
    module.hot.accept("./InitialForm_48.vue?vue&type=template&id=183c7ae7&scoped=true", function () {
      api.rerender('183c7ae7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/ProcessesForms/components/P48/InitialForm_48/InitialForm_48.vue"
export default component.exports